import React, { Suspense } from "react";
import { updateActiveUserTime } from "../../custom_functions/Functions.jsx";
const FileViewerEdit = React.lazy(() => import("../FileViewerEdit.jsx"));

class PFileViewerEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileobj: this.props.location.params,
    };
  }

  componentDidMount() {
    sessionStorage.setItem("_OrderView", "1");
    updateActiveUserTime();
  }
  
  render() {
    let file = localStorage.getItem("fileobj");
    return (
      <Suspense fallback={<div></div>}>
        <div className="newtab">
          <FileViewerEdit values={file} />
        </div>
      </Suspense>
    );
  }
}
export default PFileViewerEdit;
